import styled from "styled-components";

export const PageWrapper = styled.div`
  background-color: ${(props) => props.color};
  width: 100%;
  min-height: 80vh;
  border-radius: 16px;
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 25px;
`;
export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
`;
export const MenuButtonContainer = styled.div`
  width: 95%;
  margin-top: 3%;
  display: grid;
  grid-template-columns: 3fr 1fr;
  justify-content: center;
`;
export const DropDownContainer = styled.div`
  width: 20%;
  height: 10%;
  justify-self: start;
`;
export const UpdateButtonContainer = styled.div`
  justify-self: end;
  align-self: center;
`;

export const SubModuleContainer = styled.div`
  width: 100%;
  min-height:10px;
  border-bottom: 1px solid grey;
  // border-top: 1px solid grey;
  margin-top:2%;
`;
export const TableContainer = styled.div`
  width: 70vw;
  margin-top: 10px;
`;
export const DefaultContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15vh;
`;
